import * as tslib_1 from "tslib";
import { favoritesStore } from 'owa-favorites';
import FavoriteFolderNode from './FavoriteFolderNode';
import FavoriteCategoryNode from './FavoriteCategoryNode';
import FavoriteSearchNode from './FavoriteSearchNode';
import FavoritePersonaNode from './FavoritePersonaNode';
import { observer } from 'mobx-react';
import folderStore from 'owa-folders';
import * as React from 'react';
import getFolderViewStateFromId from 'owa-mail-folder-store/lib/selectors/getFolderViewStateFromId';
var FavoriteNode = /** @class */ (function (_super) {
    tslib_1.__extends(FavoriteNode, _super);
    function FavoriteNode() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FavoriteNode.prototype.render = function () {
        var id = this.props.favoriteId;
        if (favoritesStore.favoritesPersonaNodes.has(id)) {
            var personaNode = favoritesStore.favoritesPersonaNodes.get(id);
            if (personaNode.mainEmailAddress) {
                return (React.createElement(FavoritePersonaNode, { favoriteId: id, displayName: personaNode.displayName, emailAddress: personaNode.mainEmailAddress, personaId: personaNode.personaId, searchFolderId: personaNode.searchFolderId, dropViewState: personaNode.dropViewState, isJustAdded: personaNode.isJustAdded, isSearchFolderPopulated: personaNode.isSearchFolderPopulated }));
            }
        }
        else if (favoritesStore.favoritesFolderNodes.has(id)) {
            var folder = folderStore.folderTable.get(id);
            var folderViewState = getFolderViewStateFromId(id);
            if (folder) {
                return (React.createElement(FavoriteFolderNode, { favoriteId: id, folderId: id, displayName: folder.DisplayName, isBeingDragged: folderViewState.drag.isBeingDragged, treeType: 'favorites' }));
            }
        }
        else if (favoritesStore.favoriteSearches.has(id)) {
            var favoriteSearch = favoritesStore.favoriteSearches.get(id);
            return (React.createElement(FavoriteSearchNode, { favoriteId: id, searchQuery: id, dropViewState: favoriteSearch.dropViewState }));
        }
        else if (favoritesStore.favoriteCategories.has(id)) {
            var favoriteCategory = favoritesStore.favoriteCategories.get(id);
            return (React.createElement(FavoriteCategoryNode, { favoriteId: id, categoryId: id, dropViewState: favoriteCategory.dropViewState }));
        }
        return null;
    };
    FavoriteNode = tslib_1.__decorate([
        observer
    ], FavoriteNode);
    return FavoriteNode;
}(React.Component));
export default FavoriteNode;
//# sourceMappingURL=FavoriteNode.js.map